(ns hypnos.consumer.panels.consult.weight
  "The consult weight step."
  (:require [clojure.spec.alpha :as s]
            [clojure.string :as str]
            [hypnos.consumer.specs]
            [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; helpers

(defn- valid-weight?
  [weight]
  (s/valid? :hypnos.consumer.specs/weight weight))

(defn- enable-next?
  [state]
  (or (nil? (get-in @state [:consult :consult/weight :valid?]))
      (get-in @state [:consult :consult/weight :valid?])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; fields

(defn- navigation
  [state nav-fn]
  [:div.field.is-grouped
   [:p.control
    [:button.button.is-rounded.is-info
     {:disabled (not (enable-next? state))
      :on-click (fn [_]
                  (when (enable-next? state)
                    (nav-fn state :weight :next)))}
     (tr :ui.label/next)]]])

(defn- statement
  [consult]
  [:article.message.is-info
   [:div.message-body
    [:p (tr :ui.survey.weight/statement (:consult/service-type consult))]]])

(defn- weight-field
  [state]
  [:div.field.is-horizontal
   [:div.field-label.is-normal
    [:label.label (tr :ui.survey.weight/question)]]
   [:div.field-body
    [:div.field.is-expanded
     [:div.field.has-addons
      [:p.control.is-fullwidth
       [:input.input.is-small
        {:type       :text
         :max-length 3
         :class      (when-not (or (nil? (get-in @state [:consult :consult/weight :valid?]))
                                   (get-in @state [:consult :consult/weight :valid?]))
                       "is-danger")
         :value      (if-let [val (get-in @state [:consult :consult/weight :value])]
                       val
                       "")
         :on-change  (fn [e]
                       (let [val       (-> e .-target .-value)
                             old-value (get-in @state [:consult :consult/weight :value])
                             new-value (when-not (str/blank? val) (int val))
                             changed?  (or (get-in @state [:consult :consult/weight :dirty?])
                                           (not= new-value old-value))]
                         (swap! state assoc-in
                                [:consult :consult/weight :value]
                                new-value)
                         (swap! state assoc-in
                                [:consult :consult/weight :dirty?]
                                changed?)
                         (when (valid-weight? new-value)
                           (swap! state assoc-in
                                  [:consult :consult/weight :valid?]
                                  true))))
         :on-focus   (fn [_]
                       (swap! state assoc-in
                              [:consult :consult/weight :touched?]
                              true))
         :on-blur    (fn [_]
                       (swap! state assoc-in
                              [:consult :consult/weight :valid?]
                              (valid-weight? (get-in @state [:consult :consult/weight :value]))))}]]
      [:p.control
       [:a.button.is-static.is-small (tr :ui.label/pounds)]]]
     (when-not (or (nil? (get-in @state [:consult :consult/weight :valid?]))
                   (get-in @state [:consult :consult/weight :valid?]))
       [:p.help.is-danger (tr :ui.validation/weight)])]]])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; step

(defn step
  "The weight step"
  [state nav-fn]
  (let [consult (rf/subscribe [:consumer/consult])]
    [:div.card-content
     ;; statement
     [statement @consult]
     ;; field
     [weight-field state]
     [:hr]
     ;; navigation
     [navigation state nav-fn]]))
